import * as actions from 'app/actions/report';
import http from 'app/services/http';
import moment from 'moment';

export const reportReducer = (
    state = {
        typeItems: [],
    },
    action
) => {
    switch (action.type) {
        case 'REPORT_SET_TYPES': {
            const { items } = action.payload;

            return {
                ...state,
                typeItems: items,
            };
        }
        default:
            return state;
    }
};

export function reportTypeLoad() {
    return async function reportTypeLoadThunk(dispatch) {
        const { data } = await http.get('/report/type');
        return dispatch(actions.setTypeItems(data));
    };
}

export function reportCreate(params) {
    return async function reportCreateThunk(dispatch, getState) {
        const { name, method } = getState().report.typeItems.find((item) => item.id === params.type_id);
        const { data, headers } = await http.post(`/report/${method}`, params, {
            responseType: 'blob',
        });
        const timezoneOffset = config.timezoneOffsets.find((timezone) => String(timezone.value) === params.timezone);
        const documentLink = document.createElement('a');
        const format = headers['content-disposition'].split('.')[1].split(';')[0];
        let date = moment().format('YYYY-MM-DD HHmm');
        let from = moment(params.from).format('YYYY-MM-DD HHmm');
        let to = moment(params.to).format('YYYY-MM-DD HHmm');
        let timeZone = timezoneOffset?.title || '+03:00';
        const documentName = `${date} ${name} ${from} - ${to} ${timeZone}.${format}`;

        documentLink.href = window.URL.createObjectURL(new Blob([data]));
        documentLink.setAttribute('download', documentName);
        documentLink.click();
    };
}

export default reportReducer;
